import React from 'react';
import {Row, Col} from 'reactstrap';
import {gaSelectFromSearchedCountries} from '../gaReports';

const SearchResultComponent = (props) => {
  const searchResultString = (country) => {
    if (country.searchedCity?.trim()) {
      return `${country.searchedCity} (<bdi>${country.countryHebName}</bdi>)`;
    } else return `<bdi>${country.countryHebName}</bdi>`;
  };
  const gaAndSelectFromSearchedCountries = () => {
    gaSelectFromSearchedCountries(
      props.activeLobbyTab,
      props.startedFromPackage,
      props.isSeparatedSale,
      props.country,
      props.isBusinessIndividual
    );

    props.saveSelectedCountry(props.country);
  };

  return (
    <Row onClick={() => gaAndSelectFromSearchedCountries()}>
      <Col>
        <span className='search-result-item' dangerouslySetInnerHTML={{__html: searchResultString(props.country)}} />
      </Col>
    </Row>
  );
};

export default SearchResultComponent;
